export default {
  strict: true,
  namespaced: true,
  state: {
    token: '',
    id: '',
    title: '',
    gender: '',
    email: '',
    firstName: '',
    lastName: '',
    phone: {
      number: '',
      code: ''
    },
    ada: {
      serviceDog: false,
      wheelChairLift: false,
      loginServiceDog: false,
      loginWheelChairLift: false
    },
    bday: '',
    address: '',
    city: '',
    zip: '',
    country: '',
    passportNum: '',
    isCorporate: false,
    corporate: {
      name: '',
      logo: ''
    },
    isDirectBilling: false,
    guestFname: '',
    guestLname: '',
    guestPhone: '',
    resend: {
      ready: true,
      countdown: 0,
      cooldown: 180
    },
    firstVisit: {
      show: false,
      source: '',
      countryCode: 1,
      mobile: ''
    }
  },
  mutations: {
    reset (state) {
      state.token = ''
      state.id = ''
      state.email = ''
      state.firstName = ''
      state.lastName = ''
      state.phone = {
        number: '',
        code: ''
      }
      state.bday = ''
      state.address = ''
      state.city = ''
      state.zip = ''
      state.country = ''
      state.passportNum = ''
      state.ada = {
        serviceDog: false,
        wheelChairLift: false,
        loginServiceDog: false,
        loginWheelChairLift: false
      }
    },
    setToken (state, value) { state.token = value },
    setUserInfo (state, data) {
      state.id = data.ID
      state.email = data.email
      state.firstName = data.firstName
      state.lastName = data.lastName
      state.phone = {
        number: data.phone,
        code: data.countryCode
      }
      state.bday = data.bday
      state.country = data.country
      state.passportNum = data.passportNum
      if (data.title) state.title = data.title
      if (data.gender) state.gender = data.gender
      if (data.token) state.token = data.token
    },
    setAda (state, data) {
      state.ada.serviceDog = data.serviceDog
      state.ada.wheelChairLift = data.wheelChairLift
    },
    setLoginAda (state, data) {
      state.ada.loginServiceDog = data.serviceDog
      state.ada.loginWheelChairLift = data.wheelChairLift
    },
    setEmailSubscribed (state, value) { state.emailSubscribed = value },

    setIsCorporate (state, value) { state.isCorporate = value },
    setCorporateData (state, value) { state.corporate = value },
    setIsDirectBilling (state, value) { state.isDirectBilling = value },
    setGuestFname (state, value) { state.guestFname = value },
    setGuestLname (state, value) { state.guestLname = value },
    setGuestPhone (state, value) { state.guestPhone = value },
    setUserPhone (state, value) {
      state.phone = value
    },
    setResendReady (state, value) {
      state.resend.ready = value
    },
    setResendCountdown (state, value) {
      state.resend.countdown = value
    },
    setResendCooldown (state, value) {
      state.resend.cooldown = value
    },
    setUserData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    },
    setFirstVisitData (state, data) {
      for (let field in data) {
        state.firstVisit[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user/index.js